var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.dataLoaded ? _c('div', {
    staticClass: "text-center"
  }, [_c('v-progress-circular', {
    staticClass: "mt-6",
    attrs: {
      "size": 50,
      "color": "primary",
      "indeterminate": ""
    }
  })], 1) : _c('div', {
    staticClass: "mt-4"
  }, [_c('v-row', {
    staticClass: "my-0"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex",
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('v-btn', {
    staticClass: "white--text px-4",
    attrs: {
      "outlined": "",
      "small": "",
      "rounded": "",
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v("Добавить ")], 1)], 1)], 1), _c('PageTable', {
    attrs: {
      "table-loading": _vm.tableLoading,
      "table-headers": _vm.tableHeaders,
      "table-items": _vm.protocols.list,
      "filter": "",
      "single-expand": "",
      "single-select": "",
      "show-expand": ""
    },
    on: {
      "showItemExpanded": _vm.showProtocolLines
    },
    scopedSlots: _vm._u([{
      key: "expanded-item",
      fn: function fn(_ref) {
        var headers = _ref.headers,
            protocol = _ref.item;
        return [_c('td', {
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-data-table', {
          staticClass: "protocols-table_inner py-2 ma-2",
          attrs: {
            "headers": _vm.applicationHeaders,
            "items": _vm.currentProtocolApplications.list,
            "loading": _vm.protocolLinesLoading,
            "dense": "",
            "hide-default-footer": "",
            "loading-text": "Загрузка",
            "no-data-text": "заявлений в протокол не добавлено",
            "item-key": "id"
          }
        })], 1)];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-icon', {
          staticClass: "mr-1 edit-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Рейтинговые баллы"
          },
          on: {
            "click": function click($event) {
              return _vm.addProtocolLine(item);
            }
          }
        }, [_vm._v(" mdi-file-document-edit-outline ")]), _c('v-icon', {
          staticClass: "mr-1 edit-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Редактировать"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v(" mdi-pencil-outline ")]), _c('v-icon', {
          staticClass: "remove-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Удалить"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" mdi-trash-can-outline ")])];
      }
    }])
  })], 1)], 1)], 1), _c('ConfirmDialog', {
    attrs: {
      "dialog": _vm.confirmDialog,
      "loading": _vm.btnLoading,
      "message": "\u0412\u044B \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u0438\u0437 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430?"
    },
    on: {
      "confirm": _vm.removeProtocol,
      "closeModal": _vm.closeDialog
    }
  }), _c('ProtocolDialog', {
    attrs: {
      "dialog": _vm.dialog,
      "loading": _vm.btnLoading,
      "selectedItem": _vm.selectedItem
    },
    on: {
      "saveProtocol": _vm.saveProtocol,
      "closeModal": _vm.closeDialog
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }